import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import upLoad from '@/assets/img/upload_photo3.jpg';
import axios from 'axios';
import store from "@/store";
import CONFIG from "@/assets/js/config.js";
import {
    required,
    maxLength,
    integer,
    minValue
} from "vuelidate/lib/validators";
import { not } from 'vuelidate/lib/validators';
import ValidationService from "@/services/ValidationService";

export default {
    name: "inOutcomeCreate",
    components: {
        MainLayout,
        flatPickr,
        Select2Multiple,
    },

    mixins: [ValidationService],

    data() {
        return {
            imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
            acaYear: null,
            inOutData: {
                type: null,
                title: '',
                payment_method_id: null,
                payment_date: '',
                amount: '',
                payment_screenshot: '',
                incharge_name: '',
                remark: '',
                loginID: '',
                campus_id: '',
                class_id: '',
                acd_year_id: this.$store.state.academicYear,
            },
            academic_year: '',
            classArr: null,
            academicYearArr: null,
            paymentMethodArr: null,
            submitted: false,
            ssImage: '',
            upLoad,
            campusId: store.state.user.campus_id,
            disabled: false,
        };
    },

    validations: {
        inOutData: {
            type: {
                required
            },
            acd_year_id: {
                required,
                integer,
                notZero: not(value => value == 0)
            },
            title: {
                required,
                maxLength: maxLength(100)
            },
            payment_method_id: {
                required,
                notZero: not(value => value == 0)
            },
            payment_date: {
                required
            },
            amount: {
                required,
                integer,
                maxLength: maxLength(9),
                minValue: minValue(1)
            },
            incharge_name: {
                required,
                maxLength: maxLength(100)
            },
            remark: {
                maxLength: maxLength(1000)
            },
        },

        // ssImage :{
        //     required,
        // }

    },

    methods: {
        getClass($yearId) {
            if (!$yearId || Number($yearId) === 0) {
                this.classArr = [{
                    id: 0,
                    text: 'Select Class'
                }];
                this.inOutData.class_id = '';
                return;
            }
            axios.get("class/classList/" + $yearId, {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class'
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getPaymentMethod() {
            axios.get('paymentMethod/getPaymentMethodArray')
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Payment Method'
                    }];
                    this.paymentMethodArr = $defaultSelectOption.concat(res.data[0]);
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        removeImg() {
            this.ssImage = '';
            document.getElementById('image').value = '';
        },

        imgUpload(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return null;
            } else {
                if (e.target.files[0].type.includes("image/")) {
                    if (e.target.files[0].type == "image/gif") {
                        this.$notification.error("File not supported!", {
                            timer: 3,
                            position: "bottomCenter",
                        });
                        return null;
                    }
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        if (e.target.result.length > 5242880) {
                            this.$notification.error(this.imageLargeMsg, {
                                timer: 3,
                                position: "bottomCenter",
                            });
                        } else {
                            this.ssImage = e.target.result;
                        }
                    }
                    reader.readAsDataURL(files[0]);
                } else {
                    this.$notification.error("File not supported!", {
                        timer: 3,
                        position: "bottomCenter",
                    });
                    return null;
                }
            }
        },
        getAcademicYear() {
            axios.get('getAcademicYear', {
                params: {
                    campus_id: store.state.user.campus_id
                }
            })
            .then(res => {
                let $defaultSelectOption = [{
                    'id': 0,
                    'text': 'Select'
                }];
                this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
            }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },
        create() {
            if (this.disabled) return;
            this.submitted = true;
            this.clearValidationErrors();
            if (this.$v.$invalid) {
                return;
            }
            this.inOutData.payment_screenshot = this.ssImage;
            this.inOutData.loginID = this.$store.state.user.id;
            this.inOutData.campus_id = this.$store.state.user.campus_id;
            this.disabled = true;
            axios.post('transaction/create', this.inOutData)
                .then(res => {
                    if (res.data) {
                        this.$notification.success("Transaction Added Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({
                            name: 'transactionList'
                        })
                    }
                }).catch(error => {
                    this.printValidationError(error.response);
                    this.disabled = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        }
    },

    watch: {
        "inOutData.acd_year_id"(newVal, oldVal) {
            if (oldVal !== undefined && oldVal !== null && oldVal !== '') {
                this.inOutData.class_id = '';
            }
            this.validationErrors.acd_year_id = [];
            this.validationErrors.class_id = [];
            this.getClass(newVal);
        },
        "inOutData.class_id"() {
            this.validationErrors.class_id = [];
        },
        "inOutData.payment_method_id"() {
            this.validationErrors.payment_method_id = [];
        }
    },

    mounted() {
        this.getPaymentMethod();
        this.getAcademicYear();
    }
};
